export const Sections = {
    Messages: "messages",
    Correspondence: "correspondence",
} as const;

export type SectionName = typeof Sections[keyof typeof Sections];
